<template>
    <div>
        <headerNotice routerName="添加满赠"></headerNotice>
        <!-- 填写的数据 -->
        <div class="iptData">
            <!-- 数据填写 -->
            <el-form :model="formData" class="signUp_Form" label-width="150px">
                <el-row class="row">
                    <el-col :span="8">
                        <el-form-item label="满赠促销名称:" :required="true">
                            <el-input
                                class="inputStyle"
                                v-model="formData.activeName"
                                placeholder="不能为空，1-20个字符"
                                clearable
                                size="medium"
                                maxlength="20"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row class="row">
                    <el-col :span="8">
                        <el-form-item label="开始时间：" :required="true">
                            <el-date-picker
                                v-model="formData.startTime"
                                type="datetime"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                placeholder="选择日期时间"
                            ></el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row class="row">
                    <el-col :span="8">
                        <el-form-item label="结束时间：" :required="true">
                            <el-date-picker
                                v-model="formData.endTime"
                                type="datetime"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                placeholder="选择日期时间"
                            ></el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row class="row">
                    <el-col :span="8">
                        <el-form-item
                            :rules="{required: true}"
                            label="商品订购数量满足:"
                            label-width="138px"
                        >
                            <el-input
                                placeholder="请输入数量"
                                class="input-el"
                                v-model="formData.reach"
                                autocomplete="off"
                                type="number"
                            >
                                <template slot="append">件</template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row class="row">
                    <el-col :span="8">
                        <el-form-item :rules="{required: true}" label="赠品选择:" label-width="140px">
                            <el-button
                                style="margin-right:35px;"
                                type="success"
                                @click="openShowGiveaway()"
                            >选择赠品</el-button>
                            已选择
                            {{oneStepLastGoods1.length}}件赠品
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row class="row">
                    <el-col :span="8">
                        <el-form-item :rules="{required: true}" label="获取赠品:" label-width="138px">
                            <el-input
                                placeholder="请输入数量"
                                class="input-el"
                                v-model="formData.freebieNum"
                                autocomplete="off"
                                type="number"
                            >
                                <template slot="append">个</template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row class="row">
                    <el-col :span="7">
                        <el-form-item :rules="{required: true}" label="适合的客户:" label-width="140px">
                            <el-radio-group v-model="formData.customerScope">
                                <el-radio :label="1">全部客户</el-radio>
                                <el-radio :label="2">新客户</el-radio>
                                <el-radio :label="3">老客户</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row class="row">
                   <el-col :span="6">
                        <el-form-item label="活动范围：" :required="true">
                            <el-radio-group v-model="formData.cityScope">
                                <el-radio :label="1">全部地区</el-radio>
                                <!-- <el-radio :label="2">指定地区</el-radio> -->
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col class="sale" v-if="formData.cityScope==2" :span="4" :offset="0">
                        <el-button
                            type="primary"
                            :loading="reginBtnLoading"
                            @click="showReginDialog"
                        >选择地区</el-button>
                        <span>
                            &nbsp;&nbsp;&nbsp;&nbsp;已选择
                            <span
                                style="color:#f63b3b;"
                            >{{formData.cityCodes.length}}</span> 个地区
                        </span>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col class="sale" :span="10">
                        <el-form-item label="促销活动描述:" label-width="140px">
                            <el-input
                                type="textarea"
                                :autosize="{ minRows: 2, maxRows: 4}"
                                placeholder="请输入内容"
                                v-model="formData.content"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col class="sale" :span="10">
                        <el-form-item :rules="{required: true}" label="活动商品:" label-width="140px">
                            <el-radio-group v-model="formData.itemPropScope">
                                <el-radio :label="1">全场通用</el-radio>
                                <el-radio :label="2">指定商品</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <!-- 表格商品操作 -->
            <div class="chooseAcitveGoods" v-if="formData.itemPropScope==2">
                <div class="title">
                    <span>*</span> 选择活动商品：
                </div>
                <el-tabs v-model="activeName" class="tabs">
                    <el-tab-pane label="第一步：选择商品" disabled name="first">
                        <!-- 搜索栏 -->
                        <div class="searchBox">
                            <el-row :gutter="24">
                                <!-- 搜索框 -->
                                <el-col :span="5" :offset="0">
                                    <el-input placeholder="请输入商品名称/编号" v-model="serachForm.word"></el-input>
                                </el-col>
                                <el-col :span="2" :offset="0">
                                    <el-button type="primary" @click="goodsStartSearch">查询</el-button>
                                </el-col>
                            </el-row>
                        </div>
                        <el-table
                            class="tableBox"
                            :data="goodsList"
                            style="width: 100%"
                            :default-sort="{prop: 'date', order: 'descending'}"
                            ref="multipleTable"
                            @selection-change="handleGoodsChange"
                            v-loading="loading"
                        >
                            <el-table-column type="selection" :selectable="isCanChoose" width="55"></el-table-column>
                            <el-table-column
                                align="center"
                                prop="customer"
                                label="商品图片"
                                width="120"
                            >
                                <template slot-scope="scope">
                                    <img
                                        :src="baseUrl+scope.row.imgUrl"
                                        width="100"
                                        height="100"
                                        alt
                                    >
                                </template>
                            </el-table-column>
                            <el-table-column align="center" prop="title" label="商品名称"></el-table-column>
                            <!-- <el-table-column align="center" prop="propName" label="规格"></el-table-column>
                            <el-table-column align="center" prop="propCode" label="规格编号"></el-table-column>
                            <el-table-column align="center" prop="price" label="销售价（￥）"></el-table-column>-->
                            <el-table-column align="center" prop="itemCode" label="商品编码"></el-table-column>
                            <el-table-column align="center" prop="price" label="销售价（￥）"></el-table-column>
                            <el-table-column align="center" label="操作" width="250">
                                <template slot-scope="scope">
                                    <el-button
                                        v-if="!scope.row.checked"
                                        @click="joinDiscount(scope.row,scope.$index)"
                                        type="primary"
                                        size="small"
                                    >参加折扣</el-button>
                                    <el-button
                                        disabled
                                        v-if="scope.row.checked"
                                        type="info"
                                        size="small"
                                    >已参加</el-button>
                                    <el-button
                                        v-if="scope.row.checked"
                                        @click="cancelFirstJoin(scope.row,scope.$index)"
                                        type="danger"
                                        size="small"
                                    >取消参加</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <!--分页-->
                        <el-pagination
                            class="pagination"
                            @size-change="handleGoodsSizeChange"
                            @current-change="handleGoodsCurrentChange"
                            :page-sizes="[10, 20, 30, 40]"
                            layout="total, sizes, next"
                            :background="true"
                            next-text="点击加载更多⇣⇣"
                            :total="goodsTotalCount"
                        ></el-pagination>
                        <!-- 多选操作 -->
                        <div style="margin-top: 20px">
                            <el-button type="success" @click="choosedJoinDiscount">批量参加活动</el-button>
                        </div>
                        <div style="text-align:center;margin-bottom:20px;">
                            <el-button type="primary" @click="nextStep">查看已选择活动商品</el-button>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane disabled label="第二部：确认商品" name="second">
                        <div class="fastHandle">
                            <el-table
                                class="tableBox"
                                :data="oneStepLastGoods"
                                style="width: 100%"
                                :default-sort="{prop: 'date', order: 'descending'}"
                                ref="multipleTable"
                                @selection-change="handleSettedGoodsChange"
                                v-loading="loading"
                            >
                                <el-table-column type="selection" width="55"></el-table-column>
                                <el-table-column
                                    align="center"
                                    prop="customer"
                                    label="商品图片"
                                    width="120"
                                >
                                    <template slot-scope="scope">
                                        <img
                                            :src="baseUrl+scope.row.imgUrl"
                                            width="100"
                                            height="100"
                                            alt
                                        >
                                    </template>
                                </el-table-column>
                                <el-table-column align="center" prop="title" label="商品名称"></el-table-column>
                                <el-table-column align="center" prop="itemCode" label="商品编码"></el-table-column>
                                <el-table-column align="center" prop="price" label="销售价（￥）"></el-table-column>
                                <el-table-column align="center" class-name="handleTr" label="操作">
                                    <template slot-scope="scope">
                                        <el-row>
                                            <el-col :span="2">
                                                <el-button
                                                    size="small"
                                                    type="danger"
                                                    @click="cancelSecondJoin(scope.row,scope.$index)"
                                                >取消参与</el-button>
                                            </el-col>
                                        </el-row>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <!-- 多选操作 -->
                            <div style="margin-top: 20px">
                                <el-button type="danger" @click="choosedCancelDiscount">批量取消参与</el-button>
                            </div>
                            <div style="text-align:center;margin-bottom:20px;">
                                <el-button type="primary" @click="preStep">上一步</el-button>
                            </div>
                            <!--分页-->
                            <el-pagination
                                class="pagination"
                                layout="total"
                                :total="oneStepLastGoods.length"
                            ></el-pagination>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </div>
            <!-- 选择区域dialog框 -->
            <el-dialog
                title="请选择活动范围区域"
                class="shieldDialog"
                :visible.sync="reginDialogVisible"
                width="30%"
            >
                <el-tree
                    v-loading="dialogLoading"
                    :data="reginData"
                    show-checkbox
                    node-key="code"
                    :default-checked-keys="defaultKeys"
                    accordion
                    :props="defaultProps"
                    ref="reginTree"
                ></el-tree>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="reginDialogVisible = false">取 消</el-button>
                    <el-button type="primary" :loading="btnLoading" @click="dialogConfirmData">确 定</el-button>
                </span>
            </el-dialog>

            <!-- 表格赠品操作 -->
            <div class="add-box">
                <el-dialog width="1000px" title="选择赠品" :visible.sync="showGiveaway">
                    <div class="chooseAcitveGoods">
                        <div class="title">
                            <span>*</span> 选择活动赠品：
                        </div>
                        <el-tabs v-model="activeName1" class="tabs">
                            <el-tab-pane label="第一步：选择赠品" disabled name="first">
                                <!-- 搜索栏 -->
                                <div class="searchBox">
                                    <el-row :gutter="24">
                                        <!-- 搜索框 -->
                                        <el-col :span="5" :offset="0">
                                            <el-input placeholder="请输入赠品名称/编号" v-model="giveawayForm.word"></el-input>
                                        </el-col>
                                        <el-col :span="2" :offset="0">
                                            <el-button type="primary" @click="searchGiveaway">查询</el-button>
                                        </el-col>
                                    </el-row>
                                </div>
                                <el-table
                                    class="tableBox"
                                    :data="giveawayList"
                                    style="width: 100%"
                                    :default-sort="{prop: 'date', order: 'descending'}"
                                    ref="multipleTablezp"
                                    @selection-change="handleGiftSelectionChange"
                                    v-loading="loading"
                                >
                                    <el-table-column type="selection" :selectable="isCanChoose" width="55"></el-table-column>
                                    <el-table-column
                                        align="center"
                                        prop="customer"
                                        label="赠品图片"
                                        width="120"
                                    >
                                        <template slot-scope="scope">
                                            <img
                                                :src="baseUrl+scope.row.imgUrl"
                                                width="100"
                                                height="100"
                                                alt
                                            >
                                        </template>
                                    </el-table-column>
                                    <el-table-column align="center" prop="title" label="赠品名称"></el-table-column>
                                    <el-table-column align="center" prop="propName" label="赠品规格"></el-table-column>
                                    <el-table-column align="center" prop="price" label="销售价（￥）"></el-table-column>
                                    <el-table-column align="center" label="操作" width="250">
                                        <template slot-scope="scope">
                                            <el-button
                                                v-if="!scope.row.checked"
                                                @click="joinDiscount1(scope.row,scope.$index)"
                                                type="primary"
                                                size="small"
                                            >添加赠品</el-button>
                                            <el-button
                                                disabled
                                                v-if="scope.row.checked"
                                                type="info"
                                                size="small"
                                            >已添加</el-button>
                                            <el-button
                                                v-if="scope.row.checked"
                                                @click="cancelFirstJoin1(scope.row,scope.$index)"
                                                type="danger"
                                                size="small"
                                            >取消添加</el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                                <!--分页-->
                                <el-pagination
                                    class="pagination"
                                    @size-change="handleGoodsSizeChange1"
                                    @current-change="handleGoodsCurrentChange1"
                                    :page-sizes="[10, 20, 30, 40]"
                                    layout="total, sizes, next"
                                    :background="true"
                                    next-text="点击加载更多⇣⇣"
                                    :total="goodsTotalCount1"
                                ></el-pagination>
                                <!-- 多选操作 -->
                                <div style="margin-top: 20px">
                                    <el-button type="success" @click="choosedJoinDiscount1">批量添加赠品</el-button>
                                </div>
                                <div style="text-align:center;margin-bottom:20px;">
                                    <el-button type="primary" @click="nextStep1">查看已选择活动赠品</el-button>
                                </div>
                            </el-tab-pane>
                            <el-tab-pane disabled label="第二部：确认赠品" name="second">
                                <div class="fastHandle">
                                    <el-table
                                        class="tableBox"
                                        :data="oneStepLastGoods1"
                                        style="width: 100%"
                                        :default-sort="{prop: 'date', order: 'descending'}"
                                        ref="multipleTable"
                                        @selection-change="handleSettedGoodsChange1"
                                        v-loading="loading"
                                    >
                                        <el-table-column type="selection" width="55"></el-table-column>
                                        <el-table-column
                                            align="center"
                                            prop="customer"
                                            label="赠品图片"
                                            width="120"
                                        >
                                            <template slot-scope="scope">
                                                <img
                                                    :src="baseUrl+scope.row.imgUrl"
                                                    width="100"
                                                    height="100"
                                                    alt
                                                >
                                            </template>
                                        </el-table-column>
                                        <el-table-column align="center" prop="title" label="赠品名称"></el-table-column>
                                        <el-table-column align="center" prop="propName" label="赠品规格"></el-table-column>
                                        <el-table-column align="center" prop="price" label="销售价（￥）"></el-table-column>
                                        <el-table-column align="center" class-name="handleTr" label="操作">
                                            <template slot-scope="scope">
                                                <el-row>
                                                    <el-col :span="2">
                                                        <el-button
                                                            size="small"
                                                            type="danger"
                                                            @click="cancelSecondJoin1(scope.row,scope.$index)"
                                                        >取消添加</el-button>
                                                    </el-col>
                                                </el-row>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                    <!-- 多选操作 -->
                                    <div style="margin-top: 20px">
                                        <el-button type="danger" @click="choosedCancelDiscount1">批量取消添加</el-button>
                                    </div>
                                    <div style="text-align:center;margin-bottom:20px;">
                                        <el-button type="primary" @click="preStep1">上一步</el-button>
                                    </div>
                                    <!--分页-->
                                    <el-pagination
                                        class="pagination"
                                        layout="total"
                                        :total="oneStepLastGoods1.length"
                                    ></el-pagination>
                                </div>
                            </el-tab-pane>
                        </el-tabs>
                    </div>
                </el-dialog>
            </div>

            <!-- 保存按钮 -->
            <div style="text-align:center;">
                <el-button type="info" @click="cancel">返回</el-button>
                <el-button type="primary" :loading="btnLoading" @click="saveData">保存</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import headerNotice from './../../components/common/headerNotice.vue'
export default {
    data() {
        return {
            falg: true,
            sendID:null,
            baseUrl: this.$store.state.URL,
            loading: false,
            formData: {
                "activeName": "",
                "reach": 0,
                "freebieNum": 0,
                "title": "",
                "startTime": "",
                "endTime": "",
                "limitCount": 0,
                "customerScope": 1,
                "cityScope": 1,
                "cityCodes": [],
                "itemPropList": [],
                "itemPropScope": 1,
                "freebiePropIds": []
            },
            goodsForm: {},
            giftTotalCount: 0,
            giveawayList: [], // 赠品列表
            giveawayNum: 0, // 选中赠品数量
            showGiveaway: false, // 是否展示赠品列表弹出框
            chooseCustomerData: [], //所有选中的商品数据
            currentPageCustomer: [],//所有页选中的商品数据
            nowCurrentPageGift: [], //当前页选中的赠品数据
            currentPageGift: [], //所有页选中的赠品数据
            giveawayForm: {},
            activeName: 'first',
            activeName1: 'first',
            goodsTotalCount: 0,//商品总数据条数
            goodsTotalCount1: 0,//赠品总数据条数
            maxResultCount: 10, //默认一页显示的个数,
            cateList: [],//所有分类数据
            labelList: [],//所有变标签数据
            reginData: [],//所有区域数据
            defaultProps: {
                children: 'children',
                label: 'name'
            },
            reginBtnLoading:false,
            defaultKeys: [],//默认已勾选的区域
            reginDialogVisible: false,
            dialogLoading: false,
            btnLoading: false,
            goodsList: [],//第一步商品列表
            serachForm: {//高级搜索弹框数据
                'word': '',
            },
            singleJoinItem: [],//第一步 右边 单个 点击参加的 商品
            singleJoinItem1: [],//第一步 右边 单个 点击参加的 赠品
            choosedGoodsItem: [],//第一步 已经 勾选 的商品
            choosedGiftsItem: [],//第一步 已经 勾选 的赠品
            choosedJoinGoodsItem: [],//第一步 已经 勾选 要参加 的商品
            choosedJoinGiftsItem1: [],//第一步 已经 勾选 要参加 的赠品
            oneStepLastGoods: [],//第一步 去重  勾选等 处理完 最终的商品数组  即第二步的商品列表数组
            oneStepLastGoods1: [],//第一步 去重  勾选等 处理完 最终的赠品数组  即第二步的赠品列表数组
            canIChooseTab: true,//是否能点击第二步
            allDiscountType: 1,//1全部打折 2全部减价
            allDiscountVal: '',//全部打的折扣 或者减的价格
            secondChooseGoods: [],//第二步选择的商品
            secondChooseGoods1: [],//第二步选择的赠品
            // secondMaxResultCount:2,//第二步一页显示多少个
            clearToFixed: null//抹去角和分 2   抹去角1
        }
    },
    components: {
        headerNotice,
    },
    mounted() {
        // this.getSelectDatas();
        this.getAllRegin();
        this.getDatas();
        this.getGoodsListData({
            MaxResultCount: this.maxResultCount
        })
        this.getGiveaway({
            MaxResultCount: this.maxResultCount
        })
    },
    created() {
        if (this.$route.query.sendID) {
            this.sendID = this.$route.query.sendID;
        }
    },
    methods: {
        //获取修改之前的数据
        getDatas() {
            let self = this;
            this.loading = true;
            self.reginBtnLoading = true;
            //获取分类
            $http.GET({
                url: this.$store.state.apiUrl + "/api/services/app/AdminSendfull/GetDetail",
                params: {
                    sendID: this.sendID
                },
                success(res) {
                    self.formData = res;
                    self.oneStepLastGoods1.length = res.freebiePropIds.length; // 获取选中赠品数量
                    self.oneStepLastGoods1 = res.freebiePropList;
                    self.oneStepLastGoods = res.itemPropList;
                },
                fail(res) {
                    self.loading = false
                }
            })
        },
        //添加立减条件
        addCondition() {
            this.formData.fullReductionRank.push({
                reach: "",
                abate: "",
            });
        },
        //删除立减条件
        removeCondition(index) {
            this.formData.fullReductionRank.splice(index, 1);
        },
        //获取所有分类下拉
        getSelectDatas() {
            let self = this;
            //获取分类
            $http.GET({
                url: this.$store.state.apiUrl + "/api/services/app/AdminItem/GetCLUBList",
                success(res) {
                    self.cateList = res.cateList;
                    self.labelList = res.labelList;
                },
                fail(res) {
                }
            })
        },
        //获取所有省市数据
        getAllRegin() {
            let self = this;
            self.dialogLoading = true;
            self.reginBtnLoading = true;
            $http.GET({
                url: this.$store.state.apiUrl + "/api/services/app/AdminSecKill/GetProvinceList",
                success(res) {
                    self.reginData = res;
                    self.reginDialogVisible = false;
                    self.dialogLoading = false;
                    self.btnLoading = false;
                    if (self.formData.cityCodes.length) {
                        self.reginBtnLoading = false;
                    }
                },
                fail(res) {
                    self.dialogLoading = false;
                    self.btnLoading = false;
                }
            })
        },
        //打开地区选择器
        showReginDialog() {
            let self = this;
            self.reginDialogVisible = true;
            self.dialogLoading = true;
            if (self.formData.cityCodes.length) {
                let timer = setInterval(() => {
                    if (self.$refs.reginTree) {
                        self.$refs.reginTree.setCheckedKeys(self.formData.cityCodes);
                        self.dialogLoading = false;
                        clearInterval(timer);
                    }
                }, 10);
            }
        },
        //获取第一步中的商品列表
        getGoodsListData(params, isSearch) {
            let self = this;
            self.loading = true;
            //获取分类
            $http.GET({
                url: this.$store.state.apiUrl + "/api/services/app/AdminSendfull/GetItemPropList",
                params: params,
                success(res) {
                    if (isSearch) {
                        self.goodsList = res.items;
                    } else {
                        self.goodsList = self.goodsList.concat(res.items);
                    }
                    self.oneStepLastGoods.forEach((ele1, index1) => {
                        self.goodsList.forEach((ele2, index2) => {
                            if (ele1.itemID == ele2.itemID) {
                                self.goodsList[index2].checked = true;
                            }
                        })
                    })
                    self.goodsTotalCount = res.totalCount;
                    self.$forceUpdate();
                    self.loading = false;
                },
                fail(res) {
                    self.loading = false;
                }
            })
        },
        // 根据名称/编号/规格/规格编号  查询赠品
        searchGiveaway() {
            let self = this;
            let Word = self.giveawayForm.word;
            if (status) {
                let params = {
                    Word: Word,
                    MaxResultCount: self.maxResultCount
                };
                self.dialogLoading = true;
                $http.GET({
                    url:
                        this.$store.state.apiUrl +
                        "/api/services/app/AdminSendfull/GetFreebiePropList",
                    params: params,
                    success(res) {
                        self.giveawayList = res.items;
                        self.goodsTotalCount1 = res.totalCount;
                        self.dialogLoading = false;
                    },
                    fail(res) {
                        self.dialogLoading = false;
                    }
                });
            } else {
                let params = {
                    Word: Word,
                    MaxResultCount: self.maxResultCount
                };
                self.getGiveaway(params, true);
            }
        },
        //获取赠品列表数据
        getGiveaway(params, isSearch) {
            let self = this;
            self.dialogLoading = true;
            $http.GET({
                url:
                    this.$store.state.apiUrl +
                    "/api/services/app/AdminSendfull/GetFreebiePropList",
                params: params,
                success(res) {
                    if (isSearch) {
                        self.giveawayList = res.items;
                    } else {
                        self.giveawayList = self.giveawayList.concat(res.items);
                    }
                    self.oneStepLastGoods1.forEach((ele1, index1) => {
                        self.giveawayList.forEach((ele2, index2) => {
                            if (ele1.propID == ele2.propID) {
                                self.giveawayList[index2].checked = true;
                            }
                        })
                    })
                    self.goodsTotalCount1 = res.totalCount;
                    self.$forceUpdate();
                    self.dialogLoading = false;
                    self.loading = false;
                },
                fail(res) {
                    self.dialogLoading = false;
                    self.loading = false;
                }
            });
        },
        //赠品选择Dialog框勾选
        handleGiftSelectionChange(val) {
            this.choosedGiftsItem = val;
        },
        // 第一步 table开始搜索
        goodsStartSearch() {
            this.serachForm.MaxResultCount = this.maxResultCount;
            this.serachForm.SkipCount = 0;
            this.getGoodsListData(this.serachForm, 1);
        },
        //打开赠品选择框
        openShowGiveaway() {
            let self = this;
            this.showGiveaway = true;
            let timer = setTimeout(() => {
                self.giveawayList.forEach((ele, index) => {
                    if (ele.checked) {
                        if (self.$refs.multipleTablezp) {
                            self.$refs.multipleTablezp.toggleRowSelection(
                                ele,
                                true
                            );
                        }
                        clearTimeout(timer);
                        timer = null;
                    }
                });
            }, 50);
            timer = setTimeout(() => {
                self.giveawayList.forEach((ele1, index1) => {
                    self.currentPageGift.forEach((ele2, index2) => {
                        if (ele1.propID == ele2.propID) {
                            self.$refs.multipleTablezp.toggleRowSelection(
                                ele1,
                                true
                            );
                            clearTimeout(timer);
                            timer = null;
                        }
                    });
                });
            }, 50);
        },
        //区域选择dialog框 的确定按钮
        dialogConfirmData() {
            this.formData.cityCodes = this.$refs.reginTree.getCheckedKeys();
            this.reginDialogVisible = false;
        },
        //第一步 操作 商品参加秒杀折扣
        joinDiscount(row, index) {
            this.singleJoinItem.push(row);
            let flag = true;
            //判断最后一步的数组里是否有跟现在点击参与活动的商品有相同的itemID
            this.oneStepLastGoods.forEach((ele, index) => {
                if (ele.itemID == row.itemID) {
                    flag = false;
                }
            })
            //如果没有相同 就push
            if (flag) {
                this.oneStepLastGoods.push(row);
            }
            this.goodsList[index].checked = true;
        },
        //第一步 操作 赠品参加秒杀折扣
        joinDiscount1(row, index) {
            this.singleJoinItem1.push(row);
            
            let flag = true;
            //判断最后一步的数组里是否有跟现在点击参与活动的商品有相同的itemID
            this.oneStepLastGoods1.forEach((ele, index) => {
                if (ele.propID == row.propID) {
                    flag = false;
                }
            })
            //如果没有相同 就push
            if (flag) {
                this.oneStepLastGoods1.push(row);
            }
            this.giveawayList[index].checked = true;
        },
        //已经参加的 禁止勾选
        isCanChoose(row, index) {
            if (row.checked) {
                return false
            } else {
                return true
            }
        },
        //第一步 批量 选择商品
        handleGoodsChange(val) {
            this.choosedGoodsItem = val;
        },
        //取消第一步的参与折扣的商品
        cancelFirstJoin(row, index) {
            this.goodsList[index].checked = false;
        },
        //取消第一步的参与折扣的赠品
        cancelFirstJoin1(row, index) {
            this.giveawayList[index].checked = false;
        },
        //批量勾选参加折扣的商品
        choosedJoinDiscount(row) {
            //让勾选的商品checked = true  即参加活动
            this.choosedGoodsItem.forEach((ele, index) => {
                ele.checked = true;
            })
            //单个参与的数组与 勾选的数组合并
            let addArr = this.singleJoinItem.concat(this.choosedGoodsItem);
            addArr = addArr.concat(this.oneStepLastGoods);
            //去重   方法 详见 assets/js/common.js 中的 reduceSameOneArr()
            addArr = $commonFn.reduceSameOneArr(addArr, 'itemID');
            // 如果某个商品取消了参与  则把checked = false 商品的移除  因为splice一条数据 addArr.length遍历时减1所以最后i--
            for (let i = 0; i < addArr.length; i++) {
                if (!addArr[i].checked) {
                    addArr.splice(i, 1);
                    i--;
                }
            }
            this.oneStepLastGoods = addArr;
        },
        //批量勾选参加折扣的赠品
        choosedJoinDiscount1(row) {
            //让勾选的商品checked = true  即参加活动
            this.choosedGiftsItem.forEach((ele, index) => {
                ele.checked = true;
            })
            //单个参与的数组与 勾选的数组合并
            let addArr = this.singleJoinItem1.concat(this.choosedGiftsItem);
            addArr = addArr.concat(this.oneStepLastGoods1);
            //去重   方法 详见 assets/js/common.js 中的 reduceSameOneArr()
            addArr = $commonFn.reduceSameOneArr(addArr, 'propID');
            // 如果某个商品取消了参与  则把checked = false 商品的移除  因为splice一条数据 addArr.length遍历时减1所以最后i--
            for (let i = 0; i < addArr.length; i++) {
                if (!addArr[i].checked) {
                    addArr.splice(i, 1);
                    i--;
                }
            }
            this.oneStepLastGoods1 = addArr;
        },
        //下一步 商品
        nextStep() {
            let self = this;
            //先判断是否有checked = false 商品 有就去掉
            for (let i = 0; i < this.oneStepLastGoods.length; i++) {
                if (!this.oneStepLastGoods[i].checked) {
                    this.oneStepLastGoods.splice(i, 1);
                    i--;
                }
            }
            if (!this.oneStepLastGoods.length) {
                this.$message.error('对不起，您未选择参加活动的商品');
                return;
            } else {
                this.activeName = 'second';
            }
        },
        //下一步 赠品
        nextStep1() {
            let self = this;
            //先判断是否有checked = false 商品 有就去掉
            for (let i = 0; i < this.oneStepLastGoods1.length; i++) {
                if (!this.oneStepLastGoods1[i].checked) {
                    this.oneStepLastGoods1.splice(i, 1);
                    i--;
                }
            }
            if (!this.oneStepLastGoods1.length) {
                this.$message.error('对不起，您未选择参加活动的商品');
                return;
            } else {
                this.activeName1 = 'second';
            }
        },
        //上一步 商品
        preStep() {
            this.activeName = 'first';
        },
        //上一步 赠品
        preStep1() {
            this.activeName1 = 'first';
        },
        //第二步 判断输入值是否大于或者小于输入框的最大值以及最小值  然后给对应的输入框进行关联
        isOverMaxOrLowerThanMin(min, max, index, ways) {
            //折扣
            if (ways == 1) {
                if (this.oneStepLastGoods[index].secKillPrice < min) {
                    this.$message.error('秒杀价不能低于0元');
                    this.oneStepLastGoods[index].secKillPrice = 0;
                } else if (this.oneStepLastGoods[index].secKillPrice > max) {
                    this.$message.error('秒杀价不能高于原价' + max + '元');
                    this.oneStepLastGoods[index].secKillPrice = 0;
                }
            }
            if (ways == 2) {
                if (this.oneStepLastGoods[index].secKillStock < min) {
                    this.$message.error('库存不能低于' + min + '件');
                    this.oneStepLastGoods[index].secKillStock = 0;
                } else if (this.oneStepLastGoods[index].secKillStock > max) {
                    this.$message.error('库存不能高于最大库存' + max + '件');
                    this.oneStepLastGoods[index].secKillStock = 0;
                }
            }
        },
        //第二步 选择的商品
        handleSettedGoodsChange(val) {
            this.secondChooseGoods = val;
        },
        //第二步 选择的赠品
        handleSettedGoodsChange1(val) {
            this.secondChooseGoods1 = val;
        },
        //取消第二步的参与折扣的商品
        cancelSecondJoin(row, index) {
            this.$confirm('确定取消该商品的优惠活动吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.oneStepLastGoods[index].checked = false;
                this.oneStepLastGoods.splice(index, 1);
                this.$message({
                    type: 'success',
                    message: '取消成功!'
                });
            }).catch(() => {


            });
        },
        //取消第二步的参与折扣的赠品
        cancelSecondJoin1(row, index) {
            this.$confirm('确定取消该赠品的优惠活动吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.oneStepLastGoods1[index].checked = false;
                this.oneStepLastGoods1.splice(index, 1);
                this.$message({
                    type: 'success',
                    message: '取消成功!'
                });
            }).catch(() => {


            });
        },
        //批量勾选取消参与折扣的商品
        choosedCancelDiscount() {
            this.$confirm('确定取消已选择的商品的优惠活动吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.secondChooseGoods.forEach((ele, index) => {
                    this.secondChooseGoods[index].checked = false;
                })
                //去除相同itemID相同的两个商品
                //方法 详见 assets/js/common.js 中的 reduceSameTwoArr()
                this.oneStepLastGoods = $commonFn.reduceSameTwoArr(this.oneStepLastGoods, this.secondChooseGoods, 'itemID');
                this.$forceUpdate();
                this.$message({
                    type: 'success',
                    message: '取消成功!'
                });
            }).catch(() => {

                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });

        },
        //批量勾选取消参与折扣的赠品
        choosedCancelDiscount1() {
            this.$confirm('确定取消已选择的赠品的优惠活动吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.secondChooseGoods1.forEach((ele, index) => {
                    this.secondChooseGoods1[index].checked = false;
                })
                //去除相同itemID相同的两个商品
                //方法 详见 assets/js/common.js 中的 reduceSameTwoArr()
                this.oneStepLastGoods1 = $commonFn.reduceSameTwoArr(this.oneStepLastGoods1, this.secondChooseGoods1, 'itemID');
                this.$forceUpdate();
                this.$message({
                    type: 'success',
                    message: '取消成功!'
                });
            }).catch(() => {

                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });

        },
        //第一步 一页显示多少个商品
        handleGoodsSizeChange(val) {
            this.maxResultCount = val;
            let params = {
                MaxResultCount: val,
                SkipCount: 0,
            };
            this.goodsList = [];
            this.singleJoinItem = [];
            this.choosedJoinGoodsItem = [];
            this.oneStepLastGoods = [];
            this.secondChooseGoods = [];
            this.getGoodsListData(params);
        },
        //第一步 一页显示多少个赠品
        handleGoodsSizeChange1(val) {
            this.maxResultCount = val;
            let params = {
                Word: this.giveawayForm.word,
                MaxResultCount: val,
                SkipCount: 0,
            };
            this.giveawayList = [];
            this.singleJoinItem1 = [];
            this.choosedJoinGoodsItem1 = [];
            this.oneStepLastGoods1 = [];
            this.secondChooseGoods1 = [];
            this.getGiveaway(params);
        },
        //第一步 跳转到指定页 商品
        handleGoodsCurrentChange(val) {
            this.loading = true;
            let skipCount = (val - 1) * this.maxResultCount;
            let params = this.serachForm;
            params.MaxResultCount = this.maxResultCount;
            params.SkipCount = skipCount;
            this.getGoodsListData(params, 0);
        },
        //第一步 跳转到指定页 商品
        handleGoodsCurrentChange1(val) {
            this.loading = true;
            let skipCount = (val - 1) * this.maxResultCount;
            let params = this.giveawayForm;
            params.MaxResultCount = this.maxResultCount;
            params.SkipCount = skipCount;
            this.getGiveaway(params, 0);
        },
        //返回
        cancel() {
            this.$router.back();
        },
        //保存数据
        saveData() {
            let self = this;
            self.btnLoading = true;
            // this.formData.itemPropList = this.oneStepLastGoods;
            let itemIds = [];
            let freebiePropIds = [];
            this.oneStepLastGoods.forEach((ele, index) => {
                itemIds.push(ele.itemID)
            })
            this.oneStepLastGoods1.forEach((ele, index) => {
                freebiePropIds.push(ele.propID)
            })
            let params = this.formData;
            params.itemIds = itemIds;
            params.freebiePropIds = freebiePropIds;
            $http.PUT({
                url: this.$store.state.apiUrl + "/api/services/app/AdminSendfull/Update",
                data: params,
                success(res) {
                    self.$message({
                        type: 'success',
                        message: '修改成功!'
                    });
                    let timer = setTimeout(() => {
                        self.btnLoading = false;
                        self.$router.back();
                        clearTimeout(timer)
                    }, 1000);

                },
                fail(res) {
                    self.btnLoading = false;
                }
            })
        },
    }
}
</script>

<style lang='scss' scoped>
//填写的数据
.iptData {
    padding: 20px 50px;
    .reduceBox {
        width: 30%;
        border: 1px solid #409eff;
        padding: 20px;
        padding-bottom: 0;
        margin-bottom: 20px;
        border-radius: 6px;
        .delBtn {
            display: block;
            margin: 0 auto;
            margin-bottom: 20px;
        }
    }
    .chooseAcitveGoods {
        .title {
            width: 140px;
            font-size: 14px;
            text-align: right;
            padding-right: 10px;
            color: #606266;
            span {
                color: #f63b3b;
            }
        }

        .tabs {
            padding: 20px 50px;
            .searchBox {
                padding-top: 20px;
            }
            .tableBox {
                margin-top: 20px;
                border: 1px solid #c5c5c5;
                /deep/ .handleTr .cell .el-row {
                    display: flex;
                    justify-content: space-between;
                    input {
                        padding: 0 5px;
                        text-align: center;
                    }
                    .el-input-group__prepend {
                        padding-left: 10px;
                        padding-right: 10px;
                    }
                    .el-input-group__append {
                        padding-left: 10px;
                        padding-right: 10px;
                    }
                }
            }
            .fastHandle {
                padding: 20px 0;
                .row {
                    display: flex;
                    align-items: center;
                }
            }
            /deep/ .el-tabs__item.is-disabled {
                color: #333;
            }
            /deep/ .pagination {
                .btn-next {
                    background: #eee;
                    color: #333;
                    padding: 0 10px;
                    border-radius: 4px;
                    border: 1px solid #c5c5c5;
                }
            }
        }
    }
}
</style>